<script lang="ts" setup>
import type { Props } from './types'
import { getProductTypeLabel } from '@/utils/project'

const props = defineProps<Props>()

const { t, n } = useI18n()

const longProductType = getProductTypeLabel(props.listing.raw_listing.attributes.product_type, false, true, t)
const shortProductType = getProductTypeLabel(props.listing.raw_listing.attributes.product_type, true, true, t)
</script>

<script lang="ts">
export default {
  name: 'PdFinancialInfo'
}
</script>

<template>
  <div class="flex flex-col gap-8">
    <div class="lg:flex gap-64 pb-24 lg:pb-0">
      <div
        id="financial-info-price"
        class="w-full pb-24 lg:pb-0">
        <p class="text-14 font-semibold whitespace-nowrap pb-6 lg:pb-0">
          {{ t('from', { productType: shortProductType, areaLabel: listing.area_label }) }}
        </p>

        <p class="font-semibold whitespace-nowrap text-32 lg:text-26">
          {{ n(listing.min_price, 'currency') }}

          <span class="text-20 lg:text-14 font-medium">
            {{ listing.currency }}
          </span>
        </p>
      </div>

      <div
        v-if="listing.monthly_payments_value_raw"
        id="financial-info-monthly-payments"
        class="w-full">
        <p class="text-14 font-semibold whitespace-nowrap">
          {{ t('monthlyPaymentsFrom', { totalMonthlyPayments: listing.months_to_pay }) }}
        </p>

        <p class="font-semibold whitespace-nowrap text-32 lg:text-26">
          {{ n(listing.monthly_payments_value_raw, 'currency') }}

          <span class="text-20 lg:text-14 font-medium">
            {{ listing.currency }}
          </span>
        </p>
      </div>
    </div>

    <div class="disclaimer">
      {{ t('disclaimer', {
        value: listing.area_label,
        type: longProductType.toLowerCase(),
        n: longProductType.toLowerCase() == 'casa' ? 2 : 1
      }) }}
    </div>
  </div>
</template>

<i18n lang="json" src='./i18n' />

<style lang="scss">
.lh-roomie-v2 {
  .disclaimer {
    color: var(--color-pine-600);
    opacity: .5;
    text-align: right;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: -0.14px;
  }
}
</style>
